import LoadingButton from '@mui/lab/LoadingButton';
import React from 'react';

import { styled, useTheme } from '@mui/material/styles';
import { darken, lighten } from '@mui/system';
import { CircularProgress, Tooltip } from '@mui/material';
import { COLOR_CONSTANTS } from '../../../config/helpers/color_helper';

const UIButton = props => {
  const theme = useTheme();
  const {
    loading = false,
    text = 'Submit',
    callback = new Function(),
    disabled = false,
    loadingIndicator = <CircularProgress size="20px" />,
    startIcon = false,
    endIcon = false,
    fullWidth = false,
    variant = 'contained',
    sx = {},
    size = 'medium',
    type = 'button',
    padding = '6px 16px 6px 16px',
    backgroundColor = '',
    btnColor = '',
    color = 'primary',
    border = '',
    tooltipRequired = false,
  } = props;

  const secondaryStyles = backgroundColor
    ? {
        backgroundColor:
          variant === 'contained'
            ? COLOR_CONSTANTS[backgroundColor.toUpperCase()] || backgroundColor
            : 'transparent',
        color:
          variant === 'outlined'
            ? COLOR_CONSTANTS[backgroundColor.toUpperCase()] || backgroundColor
            : COLOR_CONSTANTS[btnColor.toUpperCase()] || btnColor,
        border:
          variant === 'outlined'
            ? `1px solid ${
                COLOR_CONSTANTS[backgroundColor.toUpperCase()] ||
                backgroundColor
              }`
            : COLOR_CONSTANTS[border.toUpperCase()] || border,
        '&:hover': {
          backgroundColor:
            variant === 'outlined'
              ? lighten(
                  COLOR_CONSTANTS[backgroundColor.toUpperCase()] ||
                    backgroundColor,
                  0.95
                )
              : darken(
                  COLOR_CONSTANTS[backgroundColor.toUpperCase()] ||
                    backgroundColor,
                  0.15
                ),
          borderColor:
            variant === 'outlined'
              ? lighten(
                  COLOR_CONSTANTS[backgroundColor.toUpperCase()] ||
                    backgroundColor,
                  0.3
                )
              : undefined,
          color:
            variant === 'outlined'
              ? COLOR_CONSTANTS[backgroundColor.toUpperCase()] ||
                backgroundColor
              : undefined,
        },
      }
    : {};

  return (
    <LoadingButton
      variant={variant}
      loading={loading}
      loadingIndicator={loadingIndicator}
      disabled={disabled}
      color={color}
      btnColor={btnColor}
      onClick={callback}
      size={size}
      fullWidth={fullWidth}
      type={type}
      startIcon={startIcon ? startIcon : <></>}
      endIcon={endIcon ? endIcon : <></>}
      sx={{ ...sx, ...secondaryStyles }}
      style={{
        padding: `${padding}`,
        textTransform: 'none',
        minWidth: 0,
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        minHeight: '3vh',
      }}
    >
      <Tooltip
        enterTouchDelay={0}
        disableInteractive
        title={tooltipRequired ? text : null}
      >
        {text}
      </Tooltip>
    </LoadingButton>
  );
};

export default UIButton;
